import * as types from './types';
import SPBackend from '../../../services/SPBackend';
import { log } from '../../../utils/jsUtils';

export const setFeedInitialized = (initialized) => ({
  type: types.SET_FEED_INITIALIZED,
  payload: initialized
});

export const setFeedLive = (isLive) => ({
  type: types.SET_FEED_LIVE,
  payload: isLive
});

export const setRequests = (requests, totalRequests) => ({
  type: types.SET_REQUESTS,
  payload: { requests, totalRequests }
});

export const setUnits = (units) => ({
  type: types.SET_UNITS,
  payload: units
});

export const setExportCSVRequests = (value) => ({
  type: types.SET_EXPORT_CSV_REQUESTS,
  payload: value
});

export const setPrintRequests = (value) => ({
  type: types.SET_PRINT_REQUESTS,
  payload: value
});

export const setFilterSelections = (selections) => ({
  type: types.SET_FILTER_SELECTIONS,
  payload: selections
});

export const setFilterOptions = (options) => ({
  type: types.SET_FILTER_OPTIONS,
  payload: options
});

export const setFilterSearchText = (searchText) => ({
  type: types.SET_FILTER_SEARCH_TEXT,
  payload: searchText
});

export const setFilterPageNumber = (pageNumber) => ({
  type: types.SET_FILTER_PAGE_NUMBER,
  payload: pageNumber
});

export const updateRequests = (requests) => ({
  type: types.UPDATE_REQUESTS,
  payload: requests
});

// Note: fetchFeed was removed - RTK Query (useGetFeedQuery in feedApi.js) is now the single source of truth for feed data

export const fetchFilterOptions = (user) => async (dispatch) => {
  try {
    const response = await SPBackend.getFilterOptions(user);
    dispatch(setFilterOptions(response.data));
  } catch (error) {
    log('[fetchFilterOptions] error:', error);
  }
};